import {
    Component,
    Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

/** Componente principal (formulário). */
@Component({
    selector: 'ndd-ng-form',
    template: require('./ndd-ng-form.component.html'),
})
export class NDDFormComponent {
    /** Id do formulário. */
    @Input() public controlId?: string;
    /** Formulário. */
    @Input() public controlForm: FormGroup;

    /** Define se o valor dos controles (dentro do form) pode ser completado automaticamente pelo navegador. */
    @Input() public controlAutocomplete?: 'off' | 'on';
    /** Disposição dos elementos. */
    @Input() public controlOrientation: 'column' | 'row' = 'row';
}
